import { Component } from "../Component";
import { Slider } from "./Slider";
export class TopSlider extends Component {
    init() {
        this._slider = new Slider(this.html);
        this._slider.init({
            slidesPerView: {
                webExtraBig: 2,
                webBig: 2,
                web3: 2,
                web2: 2,
                mob: 1
            },
            autoplay: true,
            spaceBetween: 0
        });
    }
}
